import React, { useState, useRef, useEffect } from 'react'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Lottie } from '@crello/react-lottie'
import * as animationPlay from '../../animations/play-pause-circle.json'
import tw, { css, styled } from 'twin.macro'
import {
	DolphinVideoFeature,
	DolphinVideoHolder,
	DolphinVideoContainer,
	PlayPauseBtn,
	VideoHook,
	Heading3,
	DolphinDiffParagraph,
	DolphinFeatureHolder,
	DolphinFeatureContainer,
	Feature,
	FeatureImg,
	FeatureName,
	FeatureText,
	VideoOverlay,
	ClimateCareContainer,
	TextsContainer,
	ClimateCareImage,
	LearnMore,
	ThumbnailContainer,
	Innertext
} from './styles'
import useWindowResize from '../../hooks/useWindowResize'

const DolphinDifference = ({ data, dolphinfeatures }) => {
	const { hook, videoBanner, description, image, videoThumbnail } = data
	const dolphinOptions = {
		renderNode: {
			[BLOCKS.HEADING_3]: (node, children) => <Heading3>{children}</Heading3>,
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<DolphinDiffParagraph>{children}</DolphinDiffParagraph>
			),
		},
	}

	const FeatureOptions = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<FeatureText>{children}</FeatureText>
			),
		},
	}

	const [control, setControl] = useState(false)
	const [coordinates, setCoordinates] = useState(false)
	const [hide, setHide] = useState(false)
	const [isPlaying, setIsPlaying] = useState(true)
	const play = useRef(null)
	const playVidHandler = () => {
		setControl(prev => !prev)
		setIsPlaying(prev => !prev)
		if (control === false) {
			play.current.play()
		} else {
			play.current.pause()
		}
	}
	const detectMove = () => {
		setCoordinates(true)
	}
	useEffect(() => {
		const timeout = setTimeout(() => {
			setCoordinates(false)
		}, 3000)

		return () => {
			clearTimeout(timeout)
		}
	}, [coordinates, control])

	useEffect(() => {
		if (coordinates === false && control === true) {
			setHide(true)
		} else {
			setHide(false)
		}
	}, [coordinates, control])

	const { height, width } = useWindowResize()
	return (
		<DolphinVideoFeature>
			<DolphinVideoHolder>
				<video ref={play} width="100%" height="100%" loop>
					<source src={`${videoBanner?.file?.url}`} type="video/mp4"></source>
				</video>
				<DolphinVideoContainer
					onMouseMove={e => {
						detectMove(e)
					}}
					bg={control ? '' : '#b8c2cc'}
					bgImage={
						width <= 524
							? control === false
								? videoThumbnail?.file.url
								: false
							: false
					}
				>
					<>
						<VideoOverlay>
							<ClimateCareContainer>
								{control === false ? (
									<ClimateCareImage
										src={image?.file?.url}
										alt={image?.description}
									></ClimateCareImage>
								) : (
									''
								)}
							</ClimateCareContainer>
							<TextsContainer>
								<ThumbnailContainer>
									<img
										src={videoThumbnail?.file.url}
										width="450"
										alt={videoThumbnail?.description}
										css={
											control === false
												? width <= 524
													? tw`hidden`
													: tw`block`
												: tw`hidden`
										}
									/>
									<PlayPauseBtn onClick={playVidHandler} fade={hide ? 0 : 1}>
										<Lottie
											playingState={'playing'}
											speed={0.5}
											direction={isPlaying ? 1 : -1}
											width="65px"
											height="65px"
											className="lottie-container play-pause"
											config={{
												animationData: animationPlay.default,
												loop: false,
												autoplay: false,
												renderer: 'svg',
											}}
											aria-hidden
										/>
									</PlayPauseBtn>
								</ThumbnailContainer>
								{control === false ? (
									<div>
										<VideoHook>{hook}</VideoHook>
										{documentToReactComponents(
											description.json,
											dolphinOptions
										)}
									</div>
								) : (
									''
								)}
							</TextsContainer>
						</VideoOverlay>
					</>
				</DolphinVideoContainer>
			</DolphinVideoHolder>

			<DolphinFeatureHolder>
				<DolphinFeatureContainer>
					{dolphinfeatures?.items.length > 0
						? dolphinfeatures.items.map((item, i) => {
								return (
									<Feature key={i}>
										<FeatureImg
											src={item.image.file.url}
											alt={item.image.description}
										/>
										<FeatureName>{item.name}</FeatureName>
										{documentToReactComponents(item.body.json, FeatureOptions)}
									</Feature>
								)
						  })
						: ''}
				</DolphinFeatureContainer>
				<Innertext>Dolphin automatic pool cleaners are the new benchmark in environmental sustainability for swimming pools and spas. Our robotic swimming pool cleaners are proven to reduce energy consumption by up to 83% when compared to other traditional suction pool cleaners and pressure pool cleaners. That could save you up to $350 per year in energy costs while still keeping your pool sparkling clean.</Innertext>
				<Innertext>Dolphin automatic pool cleaners save water and improve water quality with our innovative filtration system. By using a Dolphin robot for 2 to 3 hours a day you can dramatically reduce the load on your pool’s filtration system, and your total water usage for backwashes shrinks by 60-80%. You can use fewer chemicals for your pool, simply because you don’t use up as much water backwashing to waste.</Innertext>
				<Innertext>Relax and enjoy your pool, knowing that you’re using the smartest and bestselling robotic pool cleaner on the market. Dolphin swimming pool cleaners are the most environmentally friendly way to keep your pool looking crystal clear.</Innertext>
				{/* <LearnMore to={'/'}>Learn More</LearnMore> */}
			</DolphinFeatureHolder>
		</DolphinVideoFeature>
	)
}

export default DolphinDifference
